import { z } from "zod";

export const ResolutionMessage = z.object({
    type: z.literal("resolution"),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    maxBitrate: z.number().int().positive(),
});

export type ResolutionMessage = z.infer<typeof ResolutionMessage>;
